<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="chevron-up">
<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M21.2535 16.6038C21.0582 16.7991 20.7416 16.7991 20.5463 16.6038L12.3999 8.45735L4.25346 16.6038C4.05819 16.7991 3.74161 16.7991 3.54635 16.6038C3.35109 16.4085 3.35109 16.092 3.54635 15.8967L12.0463 7.39669C12.2416 7.20143 12.5582 7.20143 12.7535 7.39669L21.2535 15.8967C21.4487 16.092 21.4487 16.4085 21.2535 16.6038Z" fill="#212328"/>
</g>
</svg>
